<template>
  <div>
    {{test}}
    <div :style="{height:height,width:width}" :ref="chartName"></div>
  </div>
</template>
<script>
import { newGuid } from "@/configs/functions"
export default {
  name: "myChart",
  props: {
    test: "tttt",
    category: {
      type: String,
      default: ''
    },
    chartName: {
      type: String,
      default: newGuid()
    },
    chartType: {
      type: String,
      default: "bar" //bar,line
    },
    width: {
      type: String,
      default: "800px"
    },
    height: {
      type: String,
      default: "500px"
    },
    //图表标题
    title: {
      type: String,
      default: ""
    },
    //鼠标上至显示的文字
    tooltip: {
      type: String,
      default: "数量"
    },
    //右上角工具箱
    toolbox: {
      type: Boolean,
      default: false
    },
    //y轴的单位
    yUnit: {
      type: String,
      default: ""
    },
    //x轴的单位
    xUnit: {
      type: String,
      default: ""
    },
    /*y轴数据：
    1数组
    如：[10, 52, 200, 334, 390, 330, 220]
    2对象数组 value作为y轴的数据值为必填项，其他参数可以自定义
    如：[{value:100,key1:1,key2:2...},...]
    */
    yData: {
      type: Array,
      default: [] //
    },
    xData: {
      type: Array,
      default: [] //['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    bgColor: {
      type: String,
      default: ''//rgba(1,202,217,.2)
    },
    labelColor: {
      type: String,
      default: '#717171'//rgba(1,202,217,.2)
    },
    xAxis: {
      type: Object,
      default: null
    },
    yAxis: {
      type: Object,
      default: null
    },
    vSeries: {
      type: Array,
      default: []
    },
    /* 
    数据区域缩放
    type: 'dataZoom',
    // 可选，dataZoom 组件的 index，多个 dataZoom 组件时有用，默认为 0
    dataZoomIndex: number,
    // 开始位置的百分比，0 - 100
    start: number,
    // 结束位置的百分比，0 - 100
    end: number,
    // 开始位置的数值
    startValue: number,
    // 结束位置的数值
    endValue: number
    //组件离容器左侧的距离,'left', 'center', 'right','20%'
    left:"center",
    //组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
    top:"top",
    //组件离容器右侧的距离,'20%'
    right:"auto",
    //组件离容器下侧的距离,'20%'
    bottom:"auto",              
    */
    vDataZoom: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      chart: null
    };
  },
  created() { },
  mounted() {
    if (this.vSeries.length > 0 || (this.xData.length > 0 && this.yData.length > 0)) {
      this.initChart()
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setData(info) {
      this.xData = info.xData
      this.yData = info.yData
      this.$nextTick(() => {
        if (!this.chart) {
          this.chart = null
        }
        this.initChart()
      })
    },
    initChart() {
      var refChart = this.$refs[this.chartName]
      this.chart = echarts.init(refChart)
      var hasSeries = this.vSeries && this.vSeries.length > 0
      var series = hasSeries ? this.vSeries : [
        {
          name: this.tooltip,
          type: this.chartType,
          itemStyle: {
            normal: {
              color: (params) => {
                var colorList = [
                  "#C1232B",
                  "#B5C334",
                  "#FCCE10",
                  "#E87C25",
                  "#27727B",
                  "#FE8463",
                  "#9BCA63",
                  "#FAD860",
                  "#F3A43B",
                  "#60C0DD",
                  "#3398DB",
                  "#D7504B",
                  "#C6E579",
                  "#F4E001",
                  "#F0805A",
                  "#26C0C0"
                ];
                const index = params.dataIndex;
                const len = colorList.length;
                let color = "";
                if (index >= len) {
                  color = colorList[index % len];
                } else {
                  color = colorList[index];
                }
                return color;
              },
              label: {
                show: false,
                position: "top",
                formatter: "{b}\n{c}" + this.yUnit
              }
            }
          },
          data: this.yData
        }
      ]
      let legendData = hasSeries ? this.vSeries.map(v => {
        return v.name ? v.name : ""
      }) : [""]

      const showZoom = this.vDataZoom.length > 0
      var gridBottom = showZoom ? '40px' : '3%'
      let grid = {
        top: '3%',
        left: '3%',
        right: '4%',
        bottom: gridBottom,
        containLabel: true
      }
      if (this.title.length > 0) {
        grid = {
          left: '3%',
          right: '4%',
          bottom: gridBottom,
          containLabel: true
        }
      }
      else if (legendData.length > 0) {
        grid = {
          top: '40px',
          left: '3%',
          right: '4%',
          bottom: gridBottom,
          containLabel: true
        }
      }
      var opt = {
        color: ['#5bc0de'],
        backgroundColor: this.bgColor,
        title: {
          text: this.title,
          textStyle: {
            color: this.labelColor,
            fontWeight: 'normal',
            fontSize: 14
          },
          // right: '15px',
          // x: 'left',
          // y: 'bottom'
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: this.chartType == 'bar' ? "shadow" : "line" // 默认为直线，可选为：'line' | 'shadow'
          },
          // formatter: (v) => {
          //   console.log(11)
          //   this.test = v[0].name
          //   var text = v.name
          //   console.log(22)
          //   return text
          // }
        },
        dataZoom: this.vDataZoom,
        legend: {
          data: legendData,
          textStyle: {
            color: this.labelColor
          }
        },
        grid: grid,
        toolbox: {
          show: false,
          feature: {
            mark: { show: true },
            magicType: { show: true, type: ["line", "bar"] },
            saveAsImage: { show: true }
          }
        },
        yAxis: {
          type: "value",
          textStyle: {
            color: this.labelColor,//y轴 的文字颜色
            //  fontSize: chartFontSize
          },
          axisLabel: {
            formatter: "{value}"//+this.yUnit//y轴label格式
          },
        },
        xAxis: {
          type: "category",
          data: this.xData,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0,//标签显示挑选间隔，默认为'auto'：'auto'（自动隐藏显示不下的） | 0（全部显示） 
            // rotate:-30,//标签旋转角度，默认为0，不旋转，正值为逆时针，负值为顺时针，可选为：-90 ~ 90
            formatter: "{value}"//+this.xUnit//x轴label格式
          }
        },
        series: series
      }
      if (this.xAxis) {
        opt.xAxis = this.xAxis
        if (this.xData && this.xData.length > 0) {
          opt.xAxis.data = this.xData
        }
      }
      if (this.yAxis) {
        opt.yAxis = this.yAxis
      }
      if (this.category == 'device-data-min') {
        opt = {
          title: {
            text: this.title
          },
          grid: grid,
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'line' // 默认为直线，可选为：'line' | 'shadow'
            },
            // formatter: "{b}<br/>{c}"+this.yUnit
          },
          legend: {
            data: ['']
          },
          xAxis: {
            data: this.xData,
            // type: "category",
            // axisTick: {
            //   alignWithLabel: true
            // },
            // axisLabel: {
            //   interval: 0,//标签显示挑选间隔，默认为'auto'：'auto'（自动隐藏显示不下的） | 0（全部显示） 
            //   rotate:-90,//标签旋转角度，默认为0，不旋转，正值为逆时针，负值为顺时针，可选为：-90 ~ 90
            //   formatter: "{value}"//+this.xUnit//x轴label格式
            // }
          },
          yAxis: {
            type: "value",
            axisLabel: {
              formatter: "{value}"//+this.yUnit//y轴label格式
            }
          },
          series: [{
            name: '',
            type: 'line',
            data: this.yData
          }]
        }
      }
      // console.log(opt)
      this.chart.setOption(opt)
      this.chart.on('click', (params) => {
        // params.data为y轴的数据
        this.$emit('chartClick', params.data)
      })
    }
  }
};
</script>